// extracted by mini-css-extract-plugin
export default {"AppContainer":"App_AppContainer__emRuH","App":"App_App__WUYBX"};